module.exports = __webpack_public_path__ + "img/tu.7bc92fa4.png";